import './index.css';
import { createContext } from 'react';

const BottomSheetContext = createContext({
    contentOverlayRef: { current: null },
    height: 'content',
});

export { BottomSheetContext };
//# sourceMappingURL=BottomSheetContext.js.map
